const maybeComa = target => (target ? ', ' : '');

export default function location ({ address_line_1, city, state, zipcode } = {},
  multiline = false) {
  let result = '';

  if (address_line_1) {
    result += (address_line_1);
    if (multiline && (city || state || zipcode)) {
      result += '\n';
    }
  }

  if (city) {
    result += multiline ? city : `${maybeComa(result)}${city}`;
  }

  if (state) {
    result += `${maybeComa(result)}${state}`;
  }

  if (zipcode) {
    result += `${state ? ' ' : ', '}${zipcode}`;
  }

  return result;
}
